import angular from 'angular'
import { expenseConfig } from 'redevConfig'

const list = (expenseConfig && expenseConfig.list) || ''

const listPage = list ? require(`redevelopment/input/expenseConfig/${list.templateName}`) : require('./view/list.html')
const listCtrl = list ? require(`redevelopment/input/expenseConfig/${list.controllerName}`) : require('./list')

export default angular
    .module('input.basedata.expenseConfig', [])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('input.basedata.expenseConfig', {
                url: '/expenseConfig',
                abstract: true,
                template: '<div ui-view></div>',
                default: 'input.basedata.expenseConfig.list',
                title: '报销配置',
            })
        $stateProvider.state('input.basedata.expenseConfig.list', {
            url: '/list',
            template: listPage,
            controller: 'expenseConfigCtrl',
        })
    }]).controller('expenseConfigCtrl', listCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/input/basedata/expenseConfig/index.js